import { useAgencyFee } from '@/state/billing/useAgencyFee';
import { Panel } from '../../ConsolePanel';
import { AgencyFeePicker } from './AgencyFeePicker';

/**
 * An agency's own plan on Settings > Billing: the agency fee. Shown while it is not
 * live; once it is, the Plan card above reports it and holds the portal button. It is
 * bought on its own and works with no clients; each client then gets a plan of its own,
 * chosen from the Clients table below.
 */
export const AgencyFeePanel = () => {
  const fee = useAgencyFee();
  if (fee.isLive) return null;

  return (
    <Panel
      tourAnchor="billing-agency-fee"
      title="Agency fee"
      description={
        fee.trialAvailable
          ? 'The agency features, with a 12-day free trial. You can add clients as soon as it starts, and each client has its own plan.'
          : 'The agency features. Each client has its own plan on top.'
      }
    >
      <AgencyFeePicker fee={fee} />
    </Panel>
  );
};
